/* Component-specific styles only */
:host {
  display: block;
}
.dashboard {
  display: grid;
  gap: var(--margin-l);
}
.filters {
  display: flex;
  gap: var(--margin-xl);
  flex-wrap: wrap;
  align-items: center;
  padding: var(--padding-xxl);
  background: var(--color-bg-primary);
  border-radius: var(--border-radius);
}
.filters select,
.filters input {
  background: var(--color-bg-secondary);
  padding: var(--padding);
  border: var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-s);
}
.filters input[type="text"] {
  flex: 1;
  min-width: 200px;
}
.filters label {
  display: flex;
  align-items: center;
  gap: var(--margin);
  font-size: var(--font-size-s);
  cursor: pointer;
}
.logs-container {
  background: var(--color-bg-secondary);
  border-radius: var(--border-radius);
  padding: var(--padding-xxl);
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: "Monaco", "Menlo", "Consolas", monospace;
  font-size: var(--font-size-s);
  line-height: 1.6;
  word-break: break-word;
}
.log-entry {
  padding: var(--padding) 0;
  border-bottom: var(--border);
  display: flex;
  gap: var(--margin);
  flex-wrap: wrap;
  max-width: 100%;
}
.log-entry:last-child {
  border-bottom: none;
}
.log-timestamp {
  color: var(--color-text-secondary);
  white-space: nowrap;
  flex-shrink: 0;
}
.log-level {
  font-weight: var(--font-weight-medium);
  min-width: 50px;
  flex-shrink: 0;
}
.log-level.DEBUG {
  color: var(--color-info);
}
.log-level.INFO {
  color: var(--color-success);
}
.log-level.WARN {
  color: var(--color-warning);
}
.log-level.ERROR {
  color: var(--color-danger);
}
.log-category {
  color: var(--color-text-accent);
  flex-shrink: 0;
}
.log-message {
  color: var(--color-text-secondary);
  flex: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 0;
}
.log-meta {
  color: var(--color-text-secondary);
  font-size: var(--font-size-s);
  width: 100%;
  padding-left: var(--padding-xl);
  word-break: break-word;
  overflow-wrap: break-word;
}

@media (max-width: 768px) {
  .dashboard {
    gap: var(--padding-l);
  }
  .metrics {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--padding-l);
  }
  .metric-card {
    padding: var(--padding-xl);
  }

  .metric-value {
    font-size: var(--font-size-xxl);
  }

  .filters {
    flex-direction: column;
    align-items: stretch;
    gap: var(--padding-l);
    padding: var(--padding-xl);
  }

  .filters label {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }

  .filters select,
  .filters input {
    width: 100%;
    padding: var(--padding-l);
    font-size: var(--font-size);
  }

  .filters input[type="text"] {
    min-width: 100%;
  }

  .logs-container {
    padding: var(--padding-l);
    max-height: 400px;
    font-size: var(--font-size-s);
  }

  /* Card-style layout for mobile */
  .log-entry {
    display: block;
    background: var(--color-bg-primary);
    border: var(--border);
    border-radius: var(--border-radius);
    padding: var(--padding-l);
    margin-bottom: var(--margin-l);
  }

  .log-entry:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }

  .log-timestamp {
    display: inline-block;
    font-size: var(--font-size-s);
    font-weight: var(--font-weight-medium);
    margin-right: var(--margin);
  }

  .log-level {
    display: inline-block;
    font-size: var(--font-size-s);
    font-weight: var(--font-weight-bold);
    min-width: auto;
  }

  .log-category {
    display: block;
    font-size: var(--font-size-s);
    margin-top: var(--margin-s);
    margin-bottom: var(--margin);
    opacity: 0.8;
  }

  .log-message {
    display: block;
    font-size: var(--font-size-s);
    line-height: 1.5;
    color: var(--color-text-primary);
    margin-top: var(--margin);
  }

  .log-meta {
    display: block;
    padding-left: 0;
    margin-top: var(--margin);
    font-size: var(--font-size-s);
    opacity: 0.7;
  }
}
